<template>
	<h1>Modifier matière</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="subject">Matière</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Name"
				placeholder="Name"
			/>
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'
export default {
	data() {
		return {
			form: {
				subject: '',
			},
			errors: '',
		}
	},
	methods: {
		submit() {
			this.$store.dispatch('updateSubject', this.form)
				.then(() => {
					this.$router.push({ name: 'SuperAdminAllSubjects' })
				})
				.catch((error) => {
					this.errors = error
				})
		},
		getSubject() {
			authenticatedApiFetch(`/subjects/${this.$route.params.id}/`, { method: 'GET' })
				.then(res => res.json())
				.then(res => {
					this.form = res
				})
		},
	},
	created() {
		this.getSubject()
	},
}
</script>

<style>
</style>
